import { Logo } from '../components/Logo'
import styled from 'styled-components';
import { Aco } from '../components/Aco';

const data = [
  {en: 'Alpha-pinene',value:'0.51%',},
  {en: 'Camphene',value:'2.75%',},
  {en: '6-methylhept-5-en-2-one',value:'3.54%',},
  {en: 'Myrcene, dehydro-1,8-cineole',value:'0.21%',},
  {en: 'n-octanal',value:'0.06%',},
  {en: 'p-cymene',value:'0.05%',},
  {en: 'limonene',value:'0.63%',},
  {en: 'cis-beta-ocimene',value:'0.54%',},
  {en: 'trans-beta-ocimene',value:'0.36%',},
  {en: 'terpinolene',value:'0.11%',},
  {en: 'linalool',value:'1.88%',},
  {en: 'exo-isocitral',value:'0.11%',},
  {en: 'photocitral A',value:'0.39%',},
  {en: 'cis-isocitral',value:'0.49%',},
  {en: 'trans-isocitral',value:'1.06%',},
  {en: 'alpha-terpineol',value:'0.28%',},
  {en: 'n-decanal',value:'0.09%',},
  {en: 'nerol',value:'0.21%',},
  {en: 'neral',value:'9.87%',},
  {en: 'geraniol',value:'5.71%',},
  {en: 'geranial',value:'7.74%',},
  {en: 'neryl acetate',value:'0.04%',},
  {en: 'geranyl acetate',value:'4.30%',},
  {en: 'beta-elemene',value:'0.19%',},
  {en: 'beta-caryophyllene',value:'1.71%',},
  {en: 'trans-isoeugenol',value:'0.18%',},
  {en: 'alpha-humulene',value:'0.18%',},
  {en: 'gamma-cadinene',value:'1.29%',},
  {en: 'delta-cadinene',value:'0.18%',},
  {en: 'caryophyllene oxide',value:'0.37%',},
];

const Layout = styled.div`
  text-align: left;
  display: inline-block;
  padding: 20px;
`

const LogLayout = styled.div`
  text-align: center;
  margin: 60px 0;
`

const LeftLayout = styled.div`
  float: left;
  padding: 0 0 40px 0;
  @media screen and (min-width:960px) {
    width: 545px;
  }
`

const RightLayout = styled(LeftLayout)`
  @media screen and (min-width:960px) {
    margin: 0 0 0 40px;
    width: 335px;
  }
`

const NumberData = styled.td`
  text-align: right;
`

const detail = [
  {title: '原産国', value: 'ネパール'},
  {title: '抽出部位', value: '葉'},
  {title: '抽出方法', value: '水蒸気蒸留法'},
  {title: '学名', value: 'cymbopogon citratus'},
  {title: '科名', value: 'イネ'}
]

export const CymbopogonCitratus = () => <Layout>
  <LogLayout>
    <Logo />
  </LogLayout>
  <LeftLayout>
    <h2>使用期限</h2>
    <p>{new Date('2025-06-01T09:00:00.000Z').toLocaleDateString()}</p>
    <h2>スペック</h2>
    <table>
      <tbody>
        {detail.map((item, index) => <tr key={index}>
          <th>{item.title}</th><td>{item.value}</td>
        </tr>)}
      </tbody>
    </table>
    <h2>Certification of analysis</h2>

    <h3>1. PRODUCT IDENTIFICATION AND COMPOSITION</h3>
    <ul>
      <li>1.1 Product Name:Lemongrass 100% Organic ACO/USDA</li>
      <li>1.2 Botanical Name: Cymbopogon citratus TEST SPECIFICATION RESULT</li>
    </ul>

    <h3>2. PHYSICAL AND CHEMICAL PROPERTIES</h3>
    <ul>
      <li>2.1 Appearance:Clear free flowing liquid, Yellow to Orange-brown Conforms</li>
      <li>2.2 Odour: Fresh grassy lemon Conforms</li>
      <li>2.3 Specific Gravity: 0.8790 to 0.9070 @ 20°C Conforms</li>
      <li>2.4 Refractive Index: 1.4790 to 1.4936 @ 20°C Conforms</li>
      <li>2.5 Optical Rotation: +5.00 to -5.00 Conforms</li>
    </ul>

    <h3>3. GAS CHROMATOGRAPH ANALYSIS Results</h3>
    <table>
      <tbody>
        {data.map((item, index) => <tr key={index}>
          <th>{item.en}</th><NumberData>{item.value}</NumberData>
        </tr>)}
      </tbody>
    </table>
  </LeftLayout>
  <RightLayout>
    <Aco />
  </RightLayout>
</Layout>